import { LoaderPrimitive as e } from "./primitive/index.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/loader/loader.tsx
function n({ value: n = null, max: r = 100, size: i = "md", color: a = "primary", rootProps: o, trackProps: s, indicatorProps: c }) {
	return /* @__PURE__ */ t(e.Root, {
		...o,
		value: n,
		max: r,
		size: i,
		color: a,
		children: /* @__PURE__ */ t(e.Track, {
			...s,
			children: /* @__PURE__ */ t(e.Indicator, { ...c })
		})
	});
}
var r = Object.assign(n, e);
//#endregion
export { r as Loader };
